import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';
import { useI18n } from 'vue-i18n';

export default {
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: 'local',
    });
    return {
      t,
    };
  },
  components: {
    VueperSlides,
    VueperSlide,
  },
  data: () => ({
    autoPlaying: true,
    internalAutoPlaying: true,
    slides: [
      {
        title: 'Slide 1',
        content: {
          bgImage: 'pet1.jpg',
          h3Message: 'ourPets',
          h1Message: 'morePets',
          bttnText: 'button',
          bttnLink: 'pets',
        },
      },
      {
        title: 'Slide 2',
        content: {
          bgImage: 'sitter1.jpg',
          h3Message: 'ourSitters',
          h1Message: 'moreSitters',
          bttnText: 'button',
          bttnLink: 'sitter',
        },
      },
      {
        title: 'Slide 3',
        content: {
          bgImage: 'pet2.jpg',
          h3Message: 'ourPets',
          h1Message: 'morePets',
          bttnText: 'button',
          bttnLink: 'pets',
        },
      },
      {
        title: 'Slide 4',
        content: {
          bgImage: 'sitter2.jpg',
          h3Message: 'ourSitters',
          h1Message: 'moreSitters',
          bttnText: 'button',
          bttnLink: 'sitter',
        },
      },
    ],
  }),
};
